<div class="container-fluid">
  <page-header-search
    [isSearchInput]="false"
    [pageTitleValue]="pageTitle"
  ></page-header-search>

  <div class="card">
    <div class="card-body">
      <form [formGroup]="searchDoctorForm" (ngSubmit)="onSearchDoctor()">
        <div class="row">
          <div class="form-group d-inline-block col-2">
            <label class="filter-control-label" for="doctor-Specialty">
              Specialty
            </label>
            <select
              class="form-control"
              formControlName="doctorSpeciality"
              id="doctor-Specialty"
            >
              <option
                *ngFor="let specialty of specialtiesArray"
                [value]="specialty.id"
              >
                {{ specialty.name }}
              </option>
            </select>
          </div>
          <div class="form-group d-inline-block col-2">
            <label class="filter-control-label" for="doctor-type"> Type </label>
            <select
              class="form-control"
              formControlName="doctorType"
              id="doctor-type"
            >
              <option *ngFor="let type of doctorTypes" [value]="type.id">
                {{ type.type }}
              </option>
            </select>
          </div>
          <div class="form-group d-inline-block col-2">
            <label class="filter-control-label" for="doctor-status"
              >isOnline</label
            >
            <select
              formControlName="doctorStatus"
              class="form-control"
              id="doctor-status"
            >
              <option *ngFor="let state of booleansArray" [value]="state">
                {{ state }}
              </option>
            </select>
          </div>
          <div class="form-group d-inline-block col-2">
            <label class="filter-control-label" for="doctor-state">
              isActive</label
            >
            <select
              formControlName="doctorState"
              class="form-control"
              id="doctor-state"
            >
              <option *ngFor="let state of booleansArray" [value]="state">
                {{ state }}
              </option>
            </select>
          </div>
          <div class="form-group d-inline-block col-2">
            <label class="filter-control-label" for="doctor-emergency"
              >isEmergency</label
            >
            <select
              formControlName="doctorEmergency"
              class="form-control"
              id="doctor-emergency"
            >
              <option *ngFor="let state of [true, false]" [value]="state">
                {{ state }}
              </option>
            </select>
          </div>
          <div class="col-2 d-inline-block form-group">
            <button class="btn btn-neutral bg-blue text-white submit-btn" type="submit">
              Search
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div *ngIf="!filteredDoctorsArray.length && !emptyArray" class="row">
      <div class="col-12 text-center py-5">
        Waiting for your choices 👆
      </div>
  </div>

  <div class="row" *ngIf="emptyArray" style="text-align: center;">
    <div class="col-12 text-center py-5">
      Hmm, There are no doctors for this search criteria 🥺
    </div>
  </div>

  <div *ngIf="filteredDoctorsArray.length" class="card">
    <div class="card-body">
      <div class="table-title">
        <h3 class="title mb-0">All Doctors</h3>
        <a (click)="invertSorting()">
          <span>↑</span>
          <span class="ml--1">↓</span>
          Sort By
        </a>
      </div>
      <div class="table-responsive">
        <table class="table align-items-center table-flush">
          <thead class="thead-light">
            <tr>
              <th *ngFor="let th of theadArray">{{ th | uppercase }}</th>
            </tr>
          </thead>
          <tbody>
            <tr class="pointer" *ngFor="let item of filteredDoctorsArray">
              <td>
                <span>{{ item.fullName }}</span>
              </td>
              <td>
                <span>{{ item.arFullName }}</span>
              </td>
              <td>
                <span>{{ item.speciality }}</span>
              </td>
              <td>
                <span>{{ item.phone }}</span>
              </td>
              <td>
                <span>{{ item.Os }}</span>
              </td>
              <td>
                <div class="d-flex align-items-center">
                  <label class="custom-toggle custom-toggle-default">
                    <input
                      [checked]="item.isActive"
                      type="checkbox"
                      id="active-check"
                      (change)="onDoctorActiveChange($event, item)"
                    />
                    <span
                      class="custom-toggle-slider rounded-circle"
                      data-label-off="No"
                      data-label-on="Yes"
                    >
                    </span>
                  </label>
                </div>
              </td>
              <td>
                <div class="d-flex align-items-center">
                  <label class="custom-toggle custom-toggle-default">
                    <input
                      [checked]="item.isOnline"
                      type="checkbox"
                      id="active-check"
                      (change)="onDoctorOnlineChange($event, item)"
                    />
                    <span
                      class="custom-toggle-slider rounded-circle"
                      data-label-off="No"
                      data-label-on="Yes"
                    >
                    </span>
                  </label>
                </div>
              </td>
              <td>
                <button
                  class="btn btn-icon btn-outline-success mr-2"
                  type="button"
                  placement="top"
                  tooltip="Edit"
                  [routerLink]="['edit', item.doctorId]"
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-edit"> </i>
                  </span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div class="fab-btn" [routerLink]="'add'">
  <i class="ni ni-fat-add"></i>
</div>
